import AgendamentoAlteracaoActionTypes from './actions';

const AGENDAMENTO_INICIAL = [];

const AgendamentoAlteracaoReducer = (state = AGENDAMENTO_INICIAL, action) => {
  switch (action.type) {
    case AgendamentoAlteracaoActionTypes.SET_AGENDAMENTOS:
      if (action.payload.length > 1) {
        return action.payload.sort(
          (obj1, obj2) =>
            new Date(obj1.data_alteracao) - new Date(obj2.data_alteracao)
        );
      }
      return action.payload;
    case AgendamentoAlteracaoActionTypes.ADD_AGENDAMENTO:
      return [...state, action.payload];
    case AgendamentoAlteracaoActionTypes.REMOVE_AGENDAMENTO:
      return state.filter(agendamento => agendamento.id !== action.payload.id);
    case AgendamentoAlteracaoActionTypes.CLEAR_AGENDAMENTOS:
      return AGENDAMENTO_INICIAL;
    default:
      return state;
  }
};

export { AGENDAMENTO_INICIAL, AgendamentoAlteracaoReducer };
